const getBadgeColor = (type) => {
    if (type === "Elite") {
        return 'yellow'
    }

    if (type === 'Master') {
        return 'purple'
    }

    if (type === 'Novice') {
        return 'green'
    }
}

const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber) {
        // Remove any non-numeric characters from the phone number
        const numericPhoneNumber = phoneNumber?.replace(/\D/g, '');

        // Check the length of the numeric phone number to determine the country code
        let formattedPhoneNumber = '';
        if (numericPhoneNumber?.length === 10) {
            formattedPhoneNumber = `(${numericPhoneNumber?.slice(0, 3)}) ${numericPhoneNumber?.slice(3, 6)}-${numericPhoneNumber?.slice(6)}`;
        } else if (numericPhoneNumber?.length === 11) {
            formattedPhoneNumber = `${numericPhoneNumber?.slice(0, 1)} (${numericPhoneNumber?.slice(1, 4)}) ${numericPhoneNumber?.slice(4, 7)}-${numericPhoneNumber.slice(7)}`;
        } else if (numericPhoneNumber?.length > 11) {
            const countryCode = numericPhoneNumber?.slice(0, numericPhoneNumber?.length - 10);
            const remainingDigits = numericPhoneNumber?.slice(countryCode?.length);
            formattedPhoneNumber = `+${countryCode} (${remainingDigits?.slice(0, 3)}) ${remainingDigits?.slice(3, 6)}-${remainingDigits?.slice(6)}`;
        } else {
            // Handle other cases or display as-is if it doesn't match expected formats
            formattedPhoneNumber = numericPhoneNumber;
        }

        return formattedPhoneNumber;
    } else {
        return phoneNumber
    }
}

const truncateString = (str, maxLength) => {
    if (!str) {
        return str
    }
    if (str.length > maxLength) {
        return str.substring(0, maxLength) + '...';
    }
    return str;
}


  const calculateTotalExperience = (experiences) => {
    let totalDays = 0;
    const currentDate = new Date();
    console.log("9898989",experiences)
    experiences.forEach(exp => {
      const startDate = new Date(exp.start_date);
      const endDate = exp.end_date === "Present" ? currentDate : new Date(exp.end_date);
      
      // Calculate difference in milliseconds
      const diffTime = Math.abs(endDate - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      totalDays += diffDays;
    });
  
    // Convert total days to years, months, and remaining days
    const years = Math.floor(totalDays / 365);
    const remainingDaysAfterYears = totalDays % 365;
    const months = Math.floor(remainingDaysAfterYears / 30);
    const days = remainingDaysAfterYears % 30;
    let totalData = formatExperience(years, months, days)
    return totalData;
  }
  
  function formatExperience(years, months, days) {
    const parts = [];
    if (years > 0) parts.push(`${years} year${years !== 1 ? 's' : ''}`);
    if (months > 0) parts.push(`${months} month${months !== 1 ? 's' : ''}`);
    // if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
    
    return parts.join(', ') || '';
  }
module.exports = {
    getBadgeColor,
    formatPhoneNumber,
    truncateString,
    calculateTotalExperience
}